import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { makeStyles } from 'tss-react/mui';
import { momentParse } from '../utils/time';
import type { Event } from '../types/Event';

const useStyles = makeStyles()((theme) => ({
  iconRow: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: theme.spacing(0.5, 0),
    fontSize: theme.typography.body2.fontSize,
  },
  rowIcon: {
    marginRight: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },
}));

type Props = {
  nextEvent: Event;
};

const EventSeriesNextEvent = ({ nextEvent }: Props) => {
  const { classes } = useStyles();
  const start = momentParse(nextEvent.startAt, nextEvent.timezone);

  return (
    <div className={classes.iconRow}>
      <CalendarTodayIcon fontSize="small" className={classes.rowIcon} />
      Next: {start.format('ddd, MMM D [at] h:mm A')}
    </div>
  );
};

export default EventSeriesNextEvent;
